/* Polyfill per browser datati (Safari < 17.4, Chrome < 119): richiesti da pdfjs-dist v5 */
if (typeof Promise.withResolvers !== "function") {
    Promise.withResolvers = function () {
        let resolve, reject;
        const promise = new Promise((res, rej) => { resolve = res; reject = rej; });
        return { promise, resolve, reject };
    };
}
if (!Array.prototype.at) {
    // eslint-disable-next-line no-extend-native
    Object.defineProperty(Array.prototype, "at", {
        value(n) {
            n = Math.trunc(n) || 0;
            if (n < 0) n += this.length;
            return n < 0 || n >= this.length ? undefined : this[n];
        },
        writable: true,
        configurable: true,
    });
}
/* Protezione contro Google Translate & simili: la traduzione automatica sostituisce i nodi
   di testo del DOM e manda in crash React (removeChild/insertBefore su nodi spostati). */
if (typeof Node === "function" && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
        if (child && child.parentNode !== this) return child;
        return originalRemoveChild.apply(this, arguments);
    };
    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) return newNode;
        return originalInsertBefore.apply(this, arguments);
    };
}

